import { t } from "@lingui/macro";

import { PageHero, Prose } from "../_components/page-shell";

export const CookiePolicyPage = () => {
  return (
    <>
      <PageHero
        eyebrow={t`Legal`}
        title={t`Cookie Policy`}
        subtitle={t`How and why Izicvs uses cookies.`}
      />
      <Prose>
        <p>{t`Last updated: this policy may be updated from time to time to reflect changes in the cookies we use or in applicable law.`}</p>

        <h2>{t`What are cookies`}</h2>
        <p>{t`Cookies are small text files that a website stores on your device. They help the site remember your actions and preferences, keep you signed in, and understand how the product is used.`}</p>

        <h2>{t`Types we use`}</h2>
        <p>{t`Izicvs uses a limited set of cookies, grouped into the following categories:`}</p>
        <ul>
          <li>{t`Essential cookies, which are required for authentication, security, and remembering your preferences. Without them, core features such as signing in would not work.`}</li>
          <li>{t`Analytics cookies, which help us understand how the product is used so we can improve performance and the overall experience.`}</li>
        </ul>

        <h2>{t`Third party cookies`}</h2>
        <p>{t`Some cookies may be set by trusted third party services that we use, for example analytics and authentication providers. These partners process data on our behalf and under agreements that protect your information.`}</p>

        <h2>{t`Managing cookies`}</h2>
        <p>{t`You can control and delete cookies through your browser settings, and you can adjust your choices using the preference controls we provide. Please note that blocking essential cookies may prevent parts of Izicvs from working correctly.`}</p>

        <h2>{t`Changes`}</h2>
        <p>{t`We may update this Cookie Policy as our practices evolve. When we make changes, we will update this page so you can review the current version.`}</p>

        <h2>{t`Contact`}</h2>
        <p>{t`If you have questions about our use of cookies, please contact us at privacy@izicvs.com.`}</p>
      </Prose>
    </>
  );
};
